import { Mail, Globe } from "lucide-react";

export default function ContactSection() {
  return (
    <section
      id="contact"
      className="relative py-16 md:py-32 bg-[#1C1F26]"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Fale Conosco
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            <span className="text-[#F59E0B]">Contato</span>
          </h2>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {/* Email */}
          <a
            href="mailto:contato@kpaction.com.br"
            className="block bg-[#0F1115] border border-[#2A2F38] rounded-sm p-6 text-center hover:border-[#F59E0B]/50 transition-all group"
            data-testid="contact-email"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-[#0E3A46] rounded-sm mx-auto mb-4 group-hover:bg-[#F59E0B]/10 transition-colors">
              <Mail className="h-6 w-6 text-[#F59E0B]" />
            </div>
            <p className="text-sm font-mono tracking-wider uppercase text-[#6B7280] mb-2">
              Email
            </p>
            <p className="text-[#E5E7EB] font-medium">contato@kpaction.com.br</p>
          </a>

          {/* Website */}
          <a
            href="https://www.kpaction.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-[#0F1115] border border-[#2A2F38] rounded-sm p-6 text-center hover:border-[#F59E0B]/50 transition-all group"
            data-testid="contact-website"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-[#0E3A46] rounded-sm mx-auto mb-4 group-hover:bg-[#F59E0B]/10 transition-colors">
              <Globe className="h-6 w-6 text-[#F59E0B]" />
            </div>
            <p className="text-sm font-mono tracking-wider uppercase text-[#6B7280] mb-2">
              Website
            </p>
            <p className="text-[#E5E7EB] font-medium">www.kpaction.com.br</p>
          </a>
        </div>
      </div>
    </section>
  );
}
